import { httpBasic } from 'http';

export default {
  getMarkdownFile: url =>
    httpBasic.get(url, {
      headers: {
        Accept: 'text/x-markdown'
      }
    })
};
